import React from 'react'
import { Button, ButtonProps } from '@mui/material'
import { ConfirmCommitButton } from 'shared/ui'
import { useNoPropagateHandler } from './utils'

interface NoPropButtonProps extends ButtonProps {
  doConfirm?: boolean
}

export function NoPropagationButton({
  onClick,
  children,
  doConfirm,
  ...props
}: NoPropButtonProps) {
  const ButtonComp = doConfirm ? ConfirmCommitButton : Button
  const handler = useNoPropagateHandler(onClick)
  return (
    <ButtonComp {...props} onClick={handler}>
      {children}
    </ButtonComp>
  )
}
